import { getAuthCode } from "./getAuthCode";
export const generateNewPost = async(details) => {
    try {
      let callURL = process.env.REACT_APP_BACKEND_URL + "/createnewpost?baseMaterial=" + encodeURIComponent(details.url) + "&title=" + encodeURIComponent(details.title) + "&desc=" + encodeURIComponent(details.desc)+ "&image=" + encodeURIComponent(details.image);
      const response = await fetch(callURL, {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      console.log("Status Code:", response.status);
      console.log("OK Status:", response.ok);
      if(response.ok){
      window.location.href = '/ideas';
      }
      else{
        return false
      }
    } catch (error) {
      console.log(error);
    }
}